import * as React from 'react';
import { cn } from '@/lib/utils';

export type WfChipVariant = 'default' | 'ok' | 'amber';

export interface WfChipProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: WfChipVariant;
  /** Estado desligado (wireframe .chip.off — opacity + line-through). */
  off?: boolean;
}

/** Chip mono pill do wireframe (.chip / .chip.ok / .chip.k / .chip.off). */
export const WfChip = React.forwardRef<HTMLSpanElement, WfChipProps>(
  ({ variant = 'default', off = false, className, children, ...props }, ref) => (
    <span
      ref={ref}
      className={cn(
        'wf-chip',
        variant !== 'default' && `wf-chip-${variant}`,
        off && 'wf-chip--off',
        className
      )}
      {...props}
    >
      {children}
    </span>
  )
);
WfChip.displayName = 'WfChip';
